import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyBXXC_DPeJgg3cUS-3MYFNjMoJvJh_bg0M',
  authDomain: 'kuze-app.firebaseapp.com',
  projectId: 'kuze-app',
  storageBucket: 'kuze-app.firebasestorage.app',
  messagingSenderId: '1015246072749',
  appId: '1:1015246072749:web:3bd4b52c2280200d1a4f24',
};

const app = getApps().length === 0
  ? initializeApp(firebaseConfig)
  : getApps()[0];

export const db = getFirestore(app);
